// 站点法务/商家信息（用于隐私政策、服务条款、退款政策、页脚等）
// 注意：Stripe 等支付平台通常要求站点公开展示经营者信息与联系方式。
// 在 CRA 环境下，前端环境变量需要以 REACT_APP_ 开头。

export const LEGAL_INFO = {
  entityName: process.env.REACT_APP_LEGAL_ENTITY_NAME || '日本天流亭株式会社',
  // 建议填写可公开展示的地址（例如公司注册地址/办公地址）
  entityAddress: process.env.REACT_APP_LEGAL_ENTITY_ADDRESS || '日本国沖縄県那覇市寄宮1-35-10上間莊201号室',

  supportEmail: process.env.REACT_APP_SUPPORT_EMAIL || 'liu@tianliu.ai',
  supportPhone: process.env.REACT_APP_SUPPORT_PHONE || '098 954 5714',

  siteUrl: process.env.REACT_APP_SITE_URL || 'https://tianliu.ai/',
};

